var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentContactNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.445,
    height: 39.431,
    viewBox: "0 0 39.445 39.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Parent_Contact_Number",
    "data-name": "Parent Contact Number",
    d: "M29.659,31.4l3.4-3.4a3.321,3.321,0,0,1,3.548-.728l4.139,1.653a3.306,3.306,0,0,1,2.062,3.033v7.582A3.29,3.29,0,0,1,39.35,42.8C10.341,41,4.487,16.431,3.38,7.029a3.29,3.29,0,0,1,3.29-3.654H14a3.275,3.275,0,0,1,3.033,2.062l1.653,4.139a3.275,3.275,0,0,1-.713,3.548l-3.4,3.4S16.527,29.759,29.659,31.4Z",
    transform: "translate(-3.36 -3.375)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentContactNumber);
export default __webpack_public_path__ + "static/media/ParentContactNumber.095260ae58311861d39c8ef55bc31652.svg";
export { ForwardRef as ReactComponent };